/* eslint-disable no-console */
import adaptor from './bridgeAdaptor';
import env from '@/utils/env';

class Bridge {
  context = {}

  systemCode = '64'

  constructor(systemCode = '64') {
    if (systemCode === '64' || env.isWxMP || env.isWeixin) {
      this.context = adaptor.wx;
    } else if (systemCode === 'l3' || systemCode === '2200') {
      this.context = adaptor.boc;
    } else {
      this.context = {
        getLocation() { },
        scan() { },
        go() { },
        shock() { },
        addPhoto() { },
        uploadFile() { },
        previewImage() { },
        openWebview() { },
        getAppInfo() { },
      };
    }
    this.systemCode = systemCode;
  }

  // 手机震动
  shock(options) {
    return this.context.shock(options);
  }

  // 获取地理位置
  getLocation(options) {
    return this.context.getLocation(options);
  }

  // 调起相机和相册
  addPhoto(options) {
    return this.context.addPhoto(options);
  }

  // 调起相机和相册
  uploadFile(options) {
    return this.context.uploadFile(options);
  }

  // 图片预览
  previewImage(options) {
    return this.context.previewImage(options);
  }

  // 打开一个webview
  openWebview(options) {
    return this.context.openWebview(options);
  }

  // 获取 app 相关信息
  getAppInfo(options) {
    return this.context.getAppInfo(options);
  }

  // history.go bridge 版本
  go(options) {
    return this.context.go(options);
  }

  // 扫码
  scan(options) {
    // console.info('adaptor', this.context, 3333);
    return this.context.scan(options);
  }

  // 中行获取二维码信息
  getParams(options) {
    return this.context.getBocCustInfo(options);
  }

  closeWebview() {
    return this.context.closeWebview();
  }
}

export default new Bridge(env.systemCode);
